// extracted by mini-css-extract-plugin
var _1 = "bpl__tabs__PeH4G";
var _2 = "bpl__tabs__item__JDWBs";
var _3 = "bpl__tabs__item__m-custom__pfRD5";
var _4 = "bpl__tabs__item__m-selected__OAJD6";
var _5 = "bpl__tabs__item__title__HCvNK";
export { _1 as "tabs", _2 as "tabs__item", _3 as "tabs__item__m-custom", _4 as "tabs__item__m-selected", _5 as "tabs__item__title" }
